export default __webpack_public_path__ + "static/media/Brigand's Leggings of the Ritual Flame.7d66c322.jpg";